import { render, staticRenderFns } from "./photo-grid.vue?vue&type=template&id=755b41bb&"
import script from "./photo-grid.vue?vue&type=script&lang=ts&"
export * from "./photo-grid.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/aef.slmndr.be/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('755b41bb')) {
      api.createRecord('755b41bb', component.options)
    } else {
      api.reload('755b41bb', component.options)
    }
    module.hot.accept("./photo-grid.vue?vue&type=template&id=755b41bb&", function () {
      api.rerender('755b41bb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/projects/photo-grid.vue"
export default component.exports